import React from 'react';
import { Box } from '@mui/material';
import { AdvisoryQuoteLabel, quoteLabelTone } from './AdvisoryQuoteLabel';
import type { AdvisoryQuoteReference } from './advisoryQuoteAnchors';
import type { AdvisoryTableSourceReference } from './advisoryTableSources';

/** The shared source identity and content columns in the index and audit lists. */
export function AdvisorySourceHeading({
  references = [],
  tableReferences = [],
  children,
}: {
  references?: readonly AdvisoryQuoteReference[];
  tableReferences?: readonly AdvisoryTableSourceReference[];
  children: React.ReactNode;
}) {
  const labelled: { label: string; tone?: ReturnType<typeof quoteLabelTone> }[] = [
    ...references.map(reference => ({
      label: reference.label,
      tone: quoteLabelTone(reference.quote.status),
    })),
    ...tableReferences.map(reference => ({ label: reference.label })),
  ];
  const labels = Array.from(
    new Map(labelled.map(reference => [reference.label, reference])).values()
  );
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25 }}>
      {labels.length > 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 0.75,
            flexShrink: 0,
            maxWidth: '40%',
            paddingTop: 0.25,
          }}
        >
          {labels.map(reference => (
            <AdvisoryQuoteLabel
              key={reference.label}
              label={reference.label}
              tone={reference.tone}
            />
          ))}
        </Box>
      ) : null}
      <Box sx={{ minWidth: 0, flex: 1 }}>{children}</Box>
    </Box>
  );
}
